import { useEffect, useState } from "react";
import { industries } from "@/content/industries";
import { loadLiveIndustries } from "@/lib/cmsIndustries";
import { mergeIndustryList, type IndustryCard } from "@/lib/industryList";
import { useLanguage } from "@/i18n/LanguageContext";

const bundled = industries.map((i) => ({ slug: i.slug, title: i.title, short: i.short }));
const initial = mergeIndustryList([], bundled, new Set());

/** Live industry list (CMS + not-yet-imported bundled industries). Starts with the bundled list so the page never renders empty. */
export function useIndustryList(): IndustryCard[] {
  const { language } = useLanguage();
  const [list, setList] = useState<IndustryCard[]>(initial);
  useEffect(() => {
    let alive = true;
    loadLiveIndustries(language).then((r) => {
      if (!alive || !r.ok) return; // failed load: keep the bundled list
      setList(mergeIndustryList(r.items, bundled, r.hidden));
    }).catch(() => undefined);
    return () => { alive = false; };
  }, [language]);
  return list;
}
